export const SkyLight = () => ({
	backgroundDefault: '#E3ECEF',
	backgroundPrimary: '#FFFFFF',
	backgroundPrimary60: '#E9EEF0',
	backgroundSecondary: '#D8F6FF',
});
